/**
 * Execute a set of Promises in series. Accepts an array of functions returning Promises.
 *
 * From: https://hackernoon.com/functional-javascript-resolving-promises-sequentially-7aac18c4431e
 */
function promiseSerial(promises) {
  return promises.reduce(function (promise, func) {
    return promise.then(function (result) {
      return func().then(Array.prototype.concat.bind(result));
    });
  }, Promise.resolve([]));
}

export default promiseSerial;
//# sourceMappingURL=promiseSerial.js.map
